/**
 * Runtime environment detection utilities.
 * This module provides a single source of truth for environment checks.
 */

export const isBrowser = typeof window !== 'undefined'

export const isNode =
  typeof process !== 'undefined' &&
  process.versions != null &&
  process.versions.node != null

/**
 * Asserts that the current runtime is Node.js.
 * Throws if called in a browser environment.
 */
export function assertNodeRuntime(feature: string): void {
  if (!isNode) {
    throw new Error(
      `${feature} is only available in Node.js. ` +
        `Current environment: ${isBrowser ? 'browser' : 'unknown'}`,
    )
  }
}
